import React from 'react';
import Environment from '../shared/Environment';

export const GoogleLoginButton = () => {
  const handleLogin = () => {
    // Redirect to backend OAuth endpoint (use API_BASE for full URL redirects)
    window.location.href = Environment.API_BASE + '/api/connect/google';
  };

  return (
    <button
      type="button"
      className="btn btn-primary w-100"
      onClick={handleLogin}
    >
      <i className="fa fa-google mr-2" /> Continue with Google
    </button>
  );
};
